import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { RenewSessionModal } from '@components';
import useConnectionChange from '../useConnectionChange';
const CONNECTION_CHANGE_DESCRIPTION = 'Notamos un cambio en tu conexión o dispositivo.\n'
    + 'Ingresa tu contraseña para confirmar tu identidad y seguir usando tu cuenta con normalidad.';
const ConnectionChangeModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { hasConnectionChangeError } = useConnectionChange();
    useEffect(() => {
        if (hasConnectionChangeError) {
            setIsModalOpen(true);
        }
        else {
            setIsModalOpen(false);
        }
    }, [hasConnectionChangeError]);
    return (_jsx(RenewSessionModal, { isOpen: isModalOpen, onClose: () => setIsModalOpen(false), title: "Protegemos tu cuenta", description: CONNECTION_CHANGE_DESCRIPTION }));
};
export default ConnectionChangeModal;
